// src/config/holidays.js
// ─────────────────────────────────────────────────────────────────────────────
// SINGLE SOURCE OF TRUTH for all holiday data in PrrepX Pathshala portal.
//
// Each entry in a year's array is an object with:
//   dates    {string[]}  ISO date strings 'YYYY-MM-DD' for every holiday day
//                        (multi-day festivals list all individual dates)
//   period   {string}    Display string used in HR Manual PDF table ('14 Jan', '03-04 Mar')
//   days     {string}    Day abbreviation(s) for PDF table ('Wed', 'Tue-Wed')
//   name     {string}    Full holiday name shown everywhere (calendar, attendance, PDF)
//   count    {number}    Number of paid holiday days (> 1 for multi-day festivals)
//   category {string}    Legal category for PDF table
//   type     {string}    'Fixed' | 'Fixed3' (NI Act compulsory) | 'Moon' | 'Lunar'
//
// To add a new year: define a _YYYY array below, then add it to holidayTables.
//
// Consumers:
//   holidayTables  → generateHRManual.js (HR Manual PDF, ch14)
//   allHolidays    → Attendance.jsx, CalendarDropdown.jsx (date → name lookup)
//   allHolidays is derived automatically from holidayTables — do NOT edit it manually.
// ─────────────────────────────────────────────────────────────────────────────

// 2025 Lean Holiday List (7 total holiday entries)
const _2025 = [
  { dates: ['2025-01-26'], period: '26 Jan', days: 'Sun', name: 'Republic Day', count: 1, category: 'National Gazetted', type: 'Fixed3' },
  { dates: ['2025-03-14'], period: '14 Mar', days: 'Fri', name: 'Holi (Rangwali Holi)', count: 1, category: 'UP State / National', type: 'Fixed' },
  { dates: ['2025-08-15'], period: '15 Aug', days: 'Fri', name: 'Independence Day', count: 1, category: 'National Gazetted', type: 'Fixed3' },
  { dates: ['2025-10-02'], period: '02 Oct', days: 'Thu', name: 'Gandhi Jayanti & Dussehra (Vijaya Dashami) *', count: 1, category: 'National Gazetted', type: 'Fixed3' },
  { dates: ['2025-10-20','2025-10-21'], period: '20-21 Oct', days: 'Mon-Tue', name: 'Happy Diwali', count: 2, category: 'UP State / National', type: 'Lunar' },
];

// 2026 Lean Holiday List (7 total holiday entries)
const _2026 = [
  { dates: ['2026-01-26'], period: '26 Jan', days: 'Mon', name: 'Republic Day', count: 1, category: 'National Gazetted', type: 'Fixed3' },
  { dates: ['2026-03-04'], period: '04 Mar', days: 'Wed', name: 'Holi (Rangwali Holi)', count: 1, category: 'UP State / National', type: 'Fixed' },
  { dates: ['2026-08-15'], period: '15 Aug', days: 'Sat', name: 'Independence Day', count: 1, category: 'National Gazetted', type: 'Fixed3' },
  { dates: ['2026-10-02'], period: '02 Oct', days: 'Fri', name: 'Gandhi Jayanti', count: 1, category: 'National Gazetted', type: 'Fixed3' },
  { dates: ['2026-10-20'], period: '20 Oct', days: 'Tue', name: 'Dussehra (Vijaya Dashami) *', count: 1, category: 'UP State / National', type: 'Lunar' },
  { dates: ['2026-11-08','2026-11-09'], period: '08-09 Nov', days: 'Sun-Mon', name: 'Happy Diwali', count: 2, category: 'UP State / National', type: 'Lunar' },
];  

// ─── Master map ──────────────────────────────────────────────────────────────
// Add a new _YYYY array above and register it here each year.
export const holidayTables = {
  2025: _2025,
  2026: _2026,
};

// ─── Derived flat lookup (auto-computed — do not edit manually) ──────────────
// { 'YYYY-MM-DD': 'Holiday Name' }  — used by Attendance.jsx & CalendarDropdown.jsx
export const allHolidays = Object.values(holidayTables)
  .flatMap(entries => entries.flatMap(e => e.dates.map(d => [d, e.name])))
  .reduce((map, [d, name]) => { map[d] = name; return map; }, {});

export const normalizeDateKey = (value) => {
  if (!value) return null;
  const raw = String(value).trim();
  const match = raw.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
  if (!match) return null;
  const [, year, month, day] = match;
  return `${year}-${String(Number(month)).padStart(2, '0')}-${String(Number(day)).padStart(2, '0')}`;
};

export const getHolidayName = (value) => {
  const key = normalizeDateKey(value);
  return key ? allHolidays[key] || null : null;
};
